import calculateSceneHeight from 'helpers/calculations/calculateSceneHeight'
import calculateTilt from 'helpers/calculations/calculateTilt'
import checkForInfinityOrNaN from 'helpers/presentation/checkForInfinityOrNaN'
import { ValidationError } from 'helpers/validator/validator'

function tiltHandler(context) {
  const sceneHeight = calculateSceneHeight({
    tilt: context.value,
    cameraHeight: context.cameraHeight,
    distance: context.distance
  })

  if (sceneHeight < 0) {
    const maxTilt = calculateTilt({
      distance: context.distance,
      cameraHeight: context.cameraHeight,
      sceneHeight: 0
    })
    let displayTilt = maxTilt - context.angle / 2.0
    displayTilt = checkForInfinityOrNaN(displayTilt) ? '0' : displayTilt.toFixed(2)

    throw new ValidationError(`Max allowed tilt is ${displayTilt} at this camera height and distance`)
  }
}

/** Helpers specific to custom validation behaviour extracted out of the validator */
export default { tiltHandler }



// WEBPACK FOOTER //
// ./src/helpers/validator/validationHandlers.js